import { useTranslation } from 'react-i18next';
import { redirect, useLoaderData } from 'react-router';

import { requiresAuth } from '../../auth-loader.ts';
import { ServicePayment } from '../../components/booking/service-payment.tsx';
import { homecareReservationStore } from '../../hooks/reservation/homecare.ts';
import { toSar } from '../../hooks/use-payment-info.ts';

export default function HomecarePayments() {
  const { t } = useTranslation();
  const loaderData = useLoaderData() as Awaited<
    ReturnType<typeof homecarePaymentsLoader>
  >;

  const priceInHalalas = Math.round(
    parseFloat(loaderData.reservation.servicePrice) * 100,
  );

  return (
    <ServicePayment
      serviceLabel={loaderData.reservation.serviceName}
      amountLabel={toSar(priceInHalalas)}
      amountValue={priceInHalalas}
      description={t('homecare.paymentDescription', {
        service: loaderData.reservation.serviceName,
      })}
      metadata={{
        transferables: JSON.stringify({
          ...loaderData.reservation,
          service: 'homecare',
          uid: loaderData.identity.id,
        }),
      }}
      onInitiating={() => Promise.resolve(true)}
    />
  );
}

export async function homecarePaymentsLoader() {
  const identity = await requiresAuth();
  const reservation = homecareReservationStore.read();
  if (!reservation) {
    throw redirect('/homecare');
  }
  return { identity, reservation };
}
